<template>
  <form-wrapper :validator="$v.createDan">
    <b-modal
      id="createDanovnikModal"
      :title="$t('message.createDanTitle')"
      :ok-title="$t('message.lblSave')"
      :cancel-title="$t('message.butBack')"
      @ok.prevent="save">

      <b-form-group
        :label="$t('message.lblRok')">
        <b-form-select
          style="width: 25%; text-align: inherit"
          v-model="createDan.year"
          :options="years" />
      </b-form-group>

      <b-form-group
        :label="$t('message.lblTyp')">
        <b-form-radio-group
          class="select-form"
          v-model.trim="createDan.type"
          plain>
          <b-form-radio value="a">A</b-form-radio>
          <b-form-radio value="b">B</b-form-radio>
        </b-form-radio-group>
      </b-form-group>

      <text-group
        :align-right="false"
        :m="createDan"
        name="priezvisko"
        :input-cols="10"
        :placeholder="$t('message.lblPriez')" />
      <text-group
        :align-right="false"
        :m="createDan"
        name="meno"
        :input-cols="10"
        :placeholder="$t('message.lblMeno')" />
      <text-group
        :align-right="false"
        :m="createDan"
        name="dic"
        :input-cols="10"
        :placeholder="$t('message.lblDic') +' / '+$t('message.lblRc')" />

    </b-modal>
  </form-wrapper>
</template>

<script>
import { required, maxLength, minLength } from 'vuelidate/lib/validators'
import textGroup from '@/components/extractor/textGroup.vue'
import bFormGroup from '@/components/form-group-col8'
import restEditor from '@/mixins/restEditor'
import { containsNumber } from '@/validators'

export default {

  components: {
    bFormGroup,
    textGroup
  },

  mixins: [restEditor],

  validations: {
    createDan: {
      year: {},
      type: {
        required,
      },
      dic: {
        required,
        minLength: minLength(9),
        maxLength: maxLength(11),
      },
      priezvisko: {
        required,
        maxLength: maxLength(30),
        containsNumber,
      },
      meno: {
        required,
        maxLength: maxLength(30),
        containsNumber,
      },
    },
  },

  data() {
    return {
      createDan: {
        id: '',
        year: 20,
        typ: '',
        dic: '',
        priezvisko: '',
        meno: ''
      },
      years: [
        { value: '20', text: '2020' },
        { value: '19', text: '2019' },
        { value: '18', text: '2018' }
      ]
    }
  },

  methods: {
    async processGet() {
      return null;
    },
    async processSave() {
      this.createDan.dic = this.createDan.dic.replace('/', '');
      const responseData = await this.restDataSource.createData(this.createDan, 'subjects');
      if (responseData.id) {
        this.$router.push({ name: 'danovnik', params: { userId: responseData.id } });
      }
    },
  },
};
</script>
